export default __webpack_public_path__ + "static/media/sad-face.35b1f3c3.png";